export default "__VITE_ASSET__CGZOnjyt__"